export default __webpack_public_path__ + "static/media/thumbnail.336075f1.png";